import { ChainId } from '@yetiswap/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.BOBA]: '0xFa55DA56e875EfB4D8602DF4be158319368737E8',
  [ChainId.BOBATEST]: '0x41f53b4378813968feB39d9118171529b36b863b'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
